import ApiService from './ApiService.js';
const queryString = require('querystring')
var SizeScaleModel = {

    getSizeScales: function (companyId) {
        return new Promise(function (resolve, reject) {

            var $options = {};
            $options.url = companyId ? 'sizeScale?company_id=' + companyId : 'sizeScale'
            $options.method = "get"
            ApiService.request($options)
                .then(response => {
                    console.log(response)
                    resolve(response.data.data)
                }).catch(error => {
                    reject(error)
                })
        });
    },

    getOne: function ($id) {
        return new Promise(function (resolve, reject) {
            var $options = {};
            $options.url = 'sizeScale?id=' + $id
            $options.method = "get"
            ApiService.request($options)
                .then(response => {
                    console.log(response)
                    resolve(response.data.data)
                }).catch(error => {
                    reject(error)
                })
        });
    },

    create: function (data) {
        return new Promise(function (resolve, reject) {
            var $options = {};
            $options.url = 'sizeScale'
            $options.method = "post"
            $options.data = data
            ApiService.request($options)
                .then(response => {
                    resolve(response.data)
                }).catch(error => {
                    reject(error)
                })
        });
    },

    update: function (data) {
        return new Promise(function (resolve, reject) {
            var $options = {};
            $options.url = 'sizeScale'
            $options.method = "put"
            $options.data = data
            ApiService.request($options)
                .then(response => {
                    resolve(response.data)
                }).catch(error => {
                    reject(error)
                })
        });
    },

    delete: function (id) {
        return new Promise(function (resolve, reject) {
            var $options = {};
            $options.url = 'sizeScale/' + id
            $options.method = "delete"
            ApiService.request($options)
                .then(response => {
                    resolve(response.data)
                }).catch(error => {
                    reject(error)
                })
        });
    }
};
export default SizeScaleModel;